import { render, staticRenderFns } from "./BulkRecipesChangeOwner.vue?vue&type=template&id=0363b52c&scoped=true&"
import script from "./BulkRecipesChangeOwner.vue?vue&type=script&lang=js&"
export * from "./BulkRecipesChangeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363b52c",
  null
  
)

export default component.exports